import { QuestionStructure } from 'structure/question';
import { component, demoFile, feature } from 'system/demo';

import { ArticleTopicTaggingFeature, IndexWidget } from '../article-topic-tag';

demoFile('open-modules/zdf/feature/article-topic-tag');

feature('Tag Article Topics', {
    structureKey: 'question',
    config: QuestionStructure.receivesConfigDefaults,
    state: {
        serverCall: {
            interests: {
                getArticleTopics: async () => [],
                determineArticleTopics: async () => ['politics'],
            },
        },
        language: 'english',
    },
    features: { articletopictagging: true },
});

component('IndexWidget', IndexWidget, {
    structureKey: 'question',
    state: {
        serverCall: {
            interests: {
                getArticleTopics: async () => [],
                determineArticleTopics: async () => ['politics'],
            },
        },
        language: 'english',
    },
});
